module.exports = __webpack_public_path__ + "static/img/Noise_K.5befd64.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/handshakes/assets/Noise_K.png
// module id = +QSb
// module chunks = 1